import i18next from 'i18next';

i18next.init({
    fallbackLng: 'bg',
    resources: {
        'bg': {
            translations: require('../locales/bg/translations.json'),
        },
        'en': {
            translations: require('../locales/en/translations.json'),
        },
    },
    ns: ['translations'],
    defaultNS: 'translations',
    returnObjects: true,
    react: {
        wait: true
    }
});

i18next.languages = ['bg', 'en'];

export default i18next;